/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import Button from '@material-ui/core/Button';
import { translate } from 'react-i18next';
import Moment from 'react-moment';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import { isAdmin } from '../../.././../../../permissions/general.js';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {|
  actionDrawerStore: TypeActionDrawerStore,
  response: Object,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore', 'contractStore')
@observer
export default class ExtendContractSuccess extends React.Component<*> {
  render() {
    const { t, actionDrawerStore, response }: TypeProps = this.props;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <div className={styles['success-details']}>
            {isAdmin() ? (
              <React.Fragment>
                <h3>{t('general:contracts.messages.extension_request_sent')}</h3>
                <p>{t('general:contracts.messages.extension_request_thanks')}</p>
                <p>{t('general:contracts.messages.extension_request_receipt')}</p>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <h3>{t('general:contracts.messages.extension_request_pending')}</h3>
                <p>{t('general:contracts.messages.extension_request_review')}</p>
                <p>{t('general:contracts.messages.extension_request_granted')}</p>
              </React.Fragment>
            )}
            <ul>
              <li>
                <b>{t('general:contracts.labels.number')}:</b>
              </li>
              <li>{response.contract_number}</li>
            </ul>
            <ul>
              <li>
                <b>{t('general:assets.to_extend')}:</b>
              </li>
              <React.Fragment>
                {response.assets.map((item: Object) => {
                  return (
                    <li key={item.id}>
                      {`${item.asset_number},
                                                    ${item.manufacturer},
                                                    ${item.model}`}
                    </li>
                  );
                })}
              </React.Fragment>
            </ul>
            <ul>
              <li>
                <b>{t('general:labels.expected_end_date')}:</b>
              </li>
              <li>
                <Moment date={response.er_expected_end_date} format="MMMM DD, YYYY" />
              </li>
            </ul>
          </div>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
